import React, { useState } from 'react';
import Autocomplete from 'src/shared/components/autocomplete/Autocomplete';
import styles from 'src/app/surveys/views/new-survey-design/NewSurveyDesign.module.scss';
import { SubscriptionType, Access } from 'src/shared/types';
import { Search } from '@mui/icons-material';
import Select from 'src/shared/components/select/Select';
import { countries } from 'src/shared/data/countries';
import noop from 'lodash/noop';
import Input from 'src/shared/components/input/Input';
import useCustomer from 'src/app/customers/hooks/useCustomer';
import { useCustomerProjectsInBCQuery } from 'src/app/projects/views/project-list/state/api/projectListGraphSlice';
import useHabitatInsightsUpload from 'src/app/habitat-insights/views/habitat-insights-details/components/habitat-insights-upload/hooks/useHabitatInsightsUpload';

const subscriptionTypeOption = [
    {
        label: 'Habitat Insights',
        value: SubscriptionType.SURVEY_WITH_HABITAT_INSIGHTS,
    },
];
export const BasicInformation = () => {
    const { formState, onFormChange } = useHabitatInsightsUpload();
    const { currentCustomerId } = useCustomer();
    const [projectNameSearchText, setProjectNameSearchText] = useState('');
    const [countrySearchText, setCountrySearchText] = useState('');
    const isDisabled = formState.formMode !== Access.CREATE;
    const { data: projectsData } = useCustomerProjectsInBCQuery(
        {
            customerId: currentCustomerId,
        },
        {
            skip: !currentCustomerId,
        }
    );

    const onProjectChange = (projectName: string | null) => {
        if (!projectName) {
            return;
        }

        const selectedProjectData = projectsData?.customerProjectsInBC.projects.find(entry => entry.projectName === projectName);

        if (!selectedProjectData) {
            return;
        }

        onFormChange({
            projectId: selectedProjectData.projectId,
            projectName: projectName,
            subscriptionType: subscriptionTypeOption[0].value,
            uploadedFileContent: '',
        });
    };

    const projectNameOptions = (projectsData?.customerProjectsInBC.projects || []).map(entry => entry.projectName) || [];
    const customerName = projectsData?.customerProjectsInBC.customerName;

    if (!customerName) {
        return null;
    }

    return (
        <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Basic information</div>
            <div className={styles.formInputSection}>
                <div className={styles.formInputSectionTitle}>Customer name</div>
                <Input value={customerName} onChange={noop} disabled={true} />
            </div>
            <div className={styles.formInputSection}>
                <div className={styles.formInputSectionTitle}>Project name</div>
                <Autocomplete
                    options={['', ...projectNameOptions] || []}
                    placeholder='Search project name'
                    prefixIcon={<Search />}
                    onChange={onProjectChange}
                    onInputChange={setProjectNameSearchText}
                    inputValue={projectNameSearchText}
                    value={formState.projectName || ''}
                    disabled={isDisabled}
                />
                <div style={{ marginTop: '15px' }}></div>
            </div>
            <>
                <div className={styles.formInputSection}>
                    <div className={styles.formInputSectionTitle}>Project code</div>
                    <Input value={formState.projectId} onChange={noop} disabled={true} />
                </div>

                <div className={styles.formInputSection}>
                    <div className={styles.formInputSectionTitle}>Subscription type</div>
                    <Select
                        className={{ container: styles.selectContainer }}
                        options={subscriptionTypeOption}
                        selectedValue={subscriptionTypeOption[0].value}
                        onChange={noop}
                        width='100%'
                        isDisabled={true}
                    />
                </div>

                <div className={styles.formInputSection}>
                    <div className={styles.formInputSectionTitle}>Country</div>
                    <Autocomplete
                        options={['', ...Object.keys(countries).sort()]}
                        placeholder='Search country name'
                        prefixIcon={<Search />}
                        onChange={value => onFormChange({ country: value || '' })}
                        value={formState.country || ''}
                        onInputChange={setCountrySearchText}
                        inputValue={countrySearchText}
                        disabled={isDisabled}
                    />
                </div>
            </>
        </div>
    );
};

export default BasicInformation;
